export default __webpack_public_path__ + "static/media/rp_article.f98aae68.png";